export default "__VITE_ASSET__DrxHr0tx__"